/* ============================================================
   FORMAS — utilidades de saneamiento de anotaciones del Editor.
   Guardas defensivas para que un elemento inválido (p. ej. un `null` que se
   colara en el arreglo de formas) NUNCA llegue al bucle de dibujado y tumbe la
   app con "Cannot read properties of null (reading 'color')". Ver S-013.
   ============================================================ */

// Una forma válida es un objeto con tipo (`t`) y color en string. Todas las
// formas que crea el Editor cumplen esto; filtramos el resto por seguridad.
export function esFormaValida(f) {
  return (
    !!f &&
    typeof f === "object" &&
    typeof f.t === "string" &&
    typeof f.color === "string"
  );
}

// Devuelve solo las formas válidas de un arreglo (tolera null/undefined/no-array).
export function normalizarFormas(formas) {
  return Array.isArray(formas) ? formas.filter(esFormaValida) : [];
}
